import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Cargo, RequestResponseGetAllCargo, RequestResponseActualizar } from 'src/app/shared/models/cargo.interface';


@Injectable({
  providedIn: 'root'
})
export class CargoService {
  

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_cargos
  traerCargos(): Observable<RequestResponseGetAllCargo> {
    return this.http
    .get<RequestResponseGetAllCargo >(`${environment.API}/rrhh/cargo/`)
    .pipe(
      map((res:RequestResponseGetAllCargo) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Create_cargo
  crearCargo(cargo:Cargo): Observable<RequestResponse> {               
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/cargo/crear`,cargo)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_cargo
  traerCargoPorId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/cargo/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Eliminar_cargo
  eliminarCargo(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/cargo/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_cargo
  actualizarCargo(cargo:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/cargo/actualizar/${cargo.id}`,cargo)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  
  

  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }

}




